import { HttpEventType, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { tap } from "rxjs";
import { ServerStatusService } from "../services/server-status.service";

export function createMaintenanceInterceptor(url: string): HttpInterceptorFn {
  return function maintenanceInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
    let events = next(req);
    if (req.url.startsWith(url)) {
      const serverStatusService = inject(ServerStatusService);
      events = events.pipe(tap(event => {
        if (event.type === HttpEventType.Response) {
          if (event.status === 503) {
            serverStatusService.serverStatus.set('maintenance');
            const body = event.body;
            if (body && typeof body === 'object' && 'LockTime' in body && 'LockWindow' in body) {
              serverStatusService.maintenanceBegin.set(new Date(<string>(body['LockTime'])));
              serverStatusService.maintenanceDuration.set(<string>(body['LockWindow']));
            }
          }
          if (event.status === 200) {
            serverStatusService.serverStatus.set('ok');
          }
        }
      }));
    }
    return events;
  }
}
